import { FimpAverageTypeType } from './fimp-average-type-type.enum';
import { FimpMeasuredValueFillType } from './fimp-measured-value-fill-type.enum';
import { FimpMeasuredValueFormat } from './fimp-measured-value-format.enum';
import { FormItemMeasuredProjectOptions } from './form-item-measured-project-options.enum';
import { FormItemMeasuredProjectRefParamType } from './form-item-measured-project-ref-param-type.enum';
import { FormItemMeasuredProjectSpadType } from './form-item-measured-project-spad-type.enum';
import { FormItemMeasuredProjectSpad } from './form-item-measured-project-spad.model';
import { FormItemMeasuredProjectStatus } from './form-item-measured-project-status.enum';
import { WorkReportMeasuredValueInfo } from './work-report-measured-value-info.model';

export class FormItemMeasuredProjectInfo {
  [key: string]: any;
  formItemIds?: Array<number>;
  fieldFormItemIdMap?: { [key: string]: string };
  id?: number;
  formId?: number;
  formItemId?: number;
  formTableId?: number;
  formItemAddress?: string;
  formItemColumnNum?: number;
  itemNo?: string;
  options?: FormItemMeasuredProjectOptions;
  category?: string;
  keywords?: string;
  spadSearchType?: string;
  spadKeywordsDesc?: string;
  spadDesc?: string;
  spadType?: FormItemMeasuredProjectSpadType;
  spadValues?: Array<FormItemMeasuredProjectSpad>;
  refParamType?: FormItemMeasuredProjectRefParamType;
  refParamSpadValue?: string;
  refParamName?: string;
  refParamSymbol?: string;
  refParamVariable?: string;
  refParamValue?: string;
  mfValue?: string;
  spadValue?: string;
  measuredValue?: string;
  measuredValueFormat?: FimpMeasuredValueFormat;
  refWorkReportId?: string;
  refWorkReportMeasuredValueInfos?: Array<WorkReportMeasuredValueInfo>;
  refReportName?: string;
  refReportFileId?: string;
  refReportMerge?: string | boolean;
  measuredValueFillType?: FimpMeasuredValueFillType;
  deviationValue?: string;
  partValue?: string;
  designValue?: string;
  designValueZjExistMap?: { [key: number]: boolean };
  quantitySpec?: string;
  remarkValue?: string;
  averageValueType?: FimpAverageTypeType;
  averageValue?: string;
  qaRate?: string;
  qualifiedJudge?: string;
  sortOrder?: number;
  status?: FormItemMeasuredProjectStatus;
  editAble?: boolean;
  comment?: string;
  // 前端自用
  designValue1?: string;
  designValue2?: string;
  editable?: boolean;
  formCode?: string;
  formCopiesOrder?: number;
  message?: string;
  sectionId?: number;
  sectionItemId?: number;
  isJL?: boolean;
  isJLCJ?: boolean;
}
